

/**
 * Language resource for validation messages.
 * @type {ValidationMessages}
 */
export const validation = {
    emailRequired: "Email is required",
    emailInvalid: "Invalid email",
    dateRequired: "Date is required",
}
